<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'FactoryView',
  mounted() {
    this.$store.state.tabs = [
      {
        text: this.$t('products'),
        to: '/factory/products',
      },
      // {
      //   'text': this.$t('materials'),
      //   'to': '/factory/materials'
      // },
      {
        text: this.$t('characteristics'),
        to: '/factory/characteristics',
      },
      {
        text: this.$t('production_lines'),
        to: '/factory/lines',
      },
      {
        text: this.$t('schedule'),
        to: '/factory/schedule',
      },
      {
        text: this.$t('watchers'),
        to: '/factory/watchers',
      },
      {
        text: this.$t('resources'),
        to: '/factory/resources',
      },
      {
        text: this.$t('ticket_issues'),
        to: '/factory/ticket-issues',
      },
      {
        text: this.$t('payment_billing'),
        to: '/factory/payment',
      },
      {
        text: this.$t('integration'),
        to: '/factory/integration',
      },
    ]
  },
}
</script>
